var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.58214 0 0 3.58214 0 8C0 12.4179 3.58214 16 8 16C12.4179 16 16 12.4179 16 8C16 3.58214 12.4179 0 8 0ZM8 12.6429C7.60536 12.6429 7.28571 12.3232 7.28571 11.9286C7.28571 11.5339 7.60536 11.2143 8 11.2143C8.39464 11.2143 8.71429 11.5339 8.71429 11.9286C8.71429 12.3232 8.39464 12.6429 8 12.6429ZM9.12321 8.72322C8.9615 8.78566 8.82235 8.8954 8.72392 9.0381C8.62549 9.18081 8.57235 9.34986 8.57143 9.52321V9.92857C8.57143 10.0071 8.50714 10.0714 8.42857 10.0714H7.57143C7.49286 10.0714 7.42857 10.0071 7.42857 9.92857V9.54464C7.42857 9.13214 7.54821 8.725 7.78393 8.38571C8.01429 8.05357 8.33571 7.8 8.71429 7.65536C9.32143 7.42143 9.71429 6.9125 9.71429 6.35714C9.71429 5.56964 8.94464 4.92857 8 4.92857C7.05536 4.92857 6.28571 5.56964 6.28571 6.35714V6.49286C6.28571 6.57143 6.22143 6.63571 6.14286 6.63571H5.28571C5.20714 6.63571 5.14286 6.57143 5.14286 6.49286V6.35714C5.14286 5.65536 5.45 5 6.00714 4.5125C6.54286 4.04286 7.25 3.78571 8 3.78571C8.75 3.78571 9.45714 4.04464 9.99286 4.5125C10.55 5 10.8571 5.65536 10.8571 6.35714C10.8571 7.38929 10.1768 8.31786 9.12321 8.72322Z",
    fill: "#62718A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq);
export default __webpack_public_path__ + "static/media/faq.d0148cb7b0ad51862fc1ff13d44b331e.svg";
export { ForwardRef as ReactComponent };